<template>
  <div class="guarantee-certificate-field">
    <span class="guarantee-certificate-field__label">
      {{ label }}
    </span>
    <span class="guarantee-certificate-field__value">
      {{ value }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'GuaranteeCertificateField',
  props: {
    label: {
      type: String,
    },
    value: {
      type: [String, Number],
    },
  },
};
</script>

<style lang="scss" scoped>
.guarantee-certificate-field {
  display: flex;
  flex-direction: column;
  min-height: 42px;
  border: 1px solid #dfdfdf;
  font-size: 1rem;
  font-weight: 500;
  padding: 10px 16px;
  margin-bottom: 14px;
  &__label {
    font-size: 0.625rem;
    margin-bottom: 4px;
    color: #757575;
  }
  &__value {
    font-size: 16px;
    font-weight: 500;
  }
}
</style>
